<template>
  <div class="flex items-start">
    <div class="flex items-center gap-x-10 w-full">
      <ProductPriceSection
        v-if="product"
        :product="product"
        :is-large="true"
        :is-bold="true"
        class="text-primary-1-100 flex-col"
      />
      <ProductCartControls class="flex-grow" />
    </div>
  </div>
</template>
<script setup lang="ts">
defineComponent({
  name: 'ProductStickyBar',
});

const { product } = useProductContext();
</script>
